define( function() {
	"use strict";

	return Object.getPrototypeOf;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/getProto.js
// module id = 2325
// module chunks = 36